import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { message } from "antd";

import { CiCircleChevLeft } from "react-icons/ci";

import { AuthAction } from "../../store/actions";

import LoginLayout from "../../components/layouts/login-layout";
import { Buttons, Spacer, inputFields } from "../../components";

import { Images } from "../../config";

const VerifyOTP = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const prevData = location.state;

  const [otpCode, setOtpCode] = useState("");

  useEffect(() => {
    if (!prevData?.email) {
      navigate("/forgot-password");
    }
  }, [prevData]);

  const handleVerifyCode = () => {
    if (otpCode.length === 0) {
      message.error("Please enter code");
    } else if (otpCode.length < 4 && otpCode.length > 0) {
      message.error("Incomplete Code");
    } else {
      const body = {
        OTPCode: otpCode,
        email: prevData.email,
      };

      dispatch(
        AuthAction.VerifyOtp(body, (res) => {
          if (res.status === 200) {
            navigate("/reset-password", { state: { email: prevData.email } });
          }
        })
      );
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleVerifyCode();
    }
  };

  return (
    <LoginLayout>
      <div className="flex flex-col items-center justify-center px-[6.5em] py-[2.5em] bg-login-gradient gap-3">
        <div className="relative">
          <CiCircleChevLeft
            className="text-[2.5em] absolute -left-[4.175em] top-1 cursor-pointer"
            onClick={() => {
              window.history.back();
            }}
          />
          <img src={Images.UnivisionLogoWithText} className="h-[3.75em]" />
        </div>
        <div className="flex flex-col gap-2 items-center w-full text-center">
          <div className="text-main font-bold text-[2.5em]">OTP</div>
          <div className="text-[1.375em] font-semibold">Please enter OTP</div>
        </div>
        <inputFields.CodeInput
          value={otpCode}
          onChange={(e) => setOtpCode(e)}
          onPressEnter={handleKeyDown}
          type="number"
        />
        <Spacer height={10} />
        <Buttons.DefaultButton onClick={handleVerifyCode} width="full">
          Continue
        </Buttons.DefaultButton>
      </div>
    </LoginLayout>
  );
};

export default VerifyOTP;
